import { rootUrl as baseUrl } from './shared';
export const publisher = {
  '@type': 'Organization',
  name: 'hipages - The easiest way to find a tradie',
  url: `${baseUrl}`,
  logo: {
    '@type': 'ImageObject',
    url: 'https://assets.homeimprovementpages.com.au/images/hipages-logo-simple.png'
  }
};
